import React from 'react'
import slider4 from '../../../../assets/img/slider4_2.webp'

function SliderAbout4Sec2() {
  return (
    <section className='whu-sec'>
            <div className='container'>
                <div className='whu-sec1'>
                    <div className='whulft'><img src={slider4} alt='Digital excellence journey' width={800} height={600} loading="lazy" /></div>
                    <div className='whurgt'>
                        <div className='ffr-desc' style={{ width: "100%" }}>
                            <p>360 Bytes has a talented pool of developers, designers and strategists having years of experience in handling complex and demanding app/solution development projects for well-known brands and promising start-ups, working towards perfecting a highly streamlined and agile development process to ensure fast paced execution without compromising on quality standards.
</p>
                            <p>Our comprehensive Data Platform Services allow you to build a tightly coupled end to end data platform to unleash the power of data.
</p>
                            <ul>
                                <li>Data Integration & Management</li>
                                <li>Data Science & Analytics</li>
                                <li>Deep Learning & Machine Learning</li>
                                <li>Dashboards & Reporting</li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        </section>
  )
}

export default SliderAbout4Sec2
